import { APP_BASE_HREF } from '@angular/common';
import { AuthUtilityService, StandaloneGrpcAuthUtilityService } from '@core/auth';
import { environment } from '@environment';

export const STANDALONE_PROVIDERS = [
  {
    provide: APP_BASE_HREF,
    useValue: environment.isInternalDev ? '/' : '/chatbots/',
  },
  {
    provide: AuthUtilityService,
    useClass: StandaloneGrpcAuthUtilityService, // || StandaloneHttpAuthUtilityService in case you want to use HTTP auth
  },
];
